var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFont(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 463.982H389.566L231.5 36.717C229.188 30.428 218.812 30.428 216.5 36.717L58.434 463.982H8C3.594 463.982 0 467.564 0 471.99C0 476.418 3.594 480 8 480H136C140.406 480 144 476.418 144 471.99C144 467.564 140.406 463.982 136 463.982H75.492L126.148 327.059C126.814 327.238 127.277 327.828 128 327.828H320C320.723 327.828 321.186 327.238 321.852 327.059L372.508 463.982H312C307.594 463.982 304 467.564 304 471.99C304 476.418 307.594 480 312 480H440C444.406 480 448 476.418 448 471.99C448 467.564 444.406 463.982 440 463.982ZM131.789 311.809L224 62.559L316.211 311.809H131.789Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont);
export default __webpack_public_path__ + "static/media/font.e5728cdb47be6771a71bc45fba66af86.svg";
export { ForwardRef as ReactComponent };